import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap"
import Dropzone from "react-dropzone"
import Select from "react-select"
import Swal from "sweetalert2"
import LoadingSpinnerUpload from "./LoadingSpinner_upload"
import { useDispatch, useSelector } from "react-redux"
import { getNewCustomers } from "store/old/customer/actions"
import { getNewOperators } from "store/old/operator/actions"
import {
  useUploadEnptReportMutation,
  useDeleteReportMutation, // ADD THIS IMPORT
} from "store/enptReport/enptReport.api"
import excelimage from "../../assets/images/excel.png"
import * as XLSX from "xlsx"

const EnptReportUpload = () => {
  const dispatch = useDispatch()
  const [selectedReportFile, setSelectedReportFile] = useState([])
  const [modal_pipe_upload, setmodal_pipe_upload] = useState(false)
  const [selectedCustomer, setCustomer] = useState("")
  const [selectedOperator, setOperator] = useState("")
  const [uploadError, setUploadError] = useState("")
  const [existingReportId, setExistingReportId] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false) // ADD LOADING STATE

  const [uploadEnptReport] = useUploadEnptReportMutation()
  const [deleteReport] = useDeleteReportMutation() // ADD DELETE MUTATION

  useEffect(() => {
    dispatch(getNewCustomers())
    dispatch(getNewOperators())
  }, [dispatch])

  const customersRaw = useSelector(state => state.customer.customers || [])
  const operatorsRaw = useSelector(state => state.operator.operators || [])

  const customers = customersRaw.map(obj => ({
    id: obj.id,
    label: obj.name,
    value: obj.id,
  }))
  const operators = operatorsRaw.map(obj => ({
    id: obj.id,
    label: obj.operator_name + " " + obj.country,
    value: obj.id,
  }))

  // Build Select-friendly option lists (value/label) so react-select returns {value,label}
  const customerOptions = [
    { value: "", label: "No Customer Selected" },
    ...customers.map(c => ({ value: c.value, label: c.label })),
  ]
  const operatorOptions = [
    { value: "", label: "No Operator Selected" },
    ...operators.map(o => ({ value: o.value, label: o.label })),
  ]

  // Clear error when user changes selection
  useEffect(() => {
    if (selectedCustomer || selectedOperator) {
      setUploadError("")
      setExistingReportId(null)
    }
  }, [selectedCustomer, selectedOperator])

  function handleAcceptedServerFiles(files) {
    if (files.length !== 0) {
      setSelectedReportFile([])
      setUploadError("")
      setExistingReportId(null)

      const reader = new FileReader()
      let sheetnamecheck = true
      reader.onload = () => {
        try {
          const fileData = reader.result
          const workbook = XLSX.read(fileData, { type: "binary" })
          // Basic validation: ensure at least one sheet
          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            sheetnamecheck = false
          }
        } catch (err) {
          sheetnamecheck = false
        }

        if (!sheetnamecheck) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Incorrect File Uploaded. Please upload a valid ENPT report file",
          })
          return
        }

        files.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size),
          })
        )
        setSelectedReportFile(files)
      }
      reader.readAsBinaryString(files[0])
    }
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  async function UploadButtonHandler() {
    if (selectedCustomer && selectedOperator) {
      const dateToday = new Date()
      const timestamp = Date.parse(dateToday)
      setmodal_pipe_upload(true)
      setUploadError("")
      setExistingReportId(null)

      try {
        const formData = new FormData()
        const key = []

        // single report file from dropzone
        const reportFile = selectedReportFile[0]
        if (reportFile) formData.append("report", reportFile)

        // metadata
        formData.append("customer", selectedCustomer)
        formData.append("operator", selectedOperator)
        formData.append("timeStamp", timestamp)
        formData.append("keys", JSON.stringify(key))

        const result = await uploadEnptReport({ data: formData }).unwrap()
        setmodal_pipe_upload(false)
        Swal.fire({
          title: "Upload Success!",
          text: `Successfully processed ${
            result.data?.processedRows || 0
          } records`,
          icon: "success",
        })
        setCustomer("")
        setOperator("")
        setSelectedReportFile([])
        setUploadError("")
        setExistingReportId(null)
      } catch (err) {
        console.error("Upload error:", err)
        setmodal_pipe_upload(false)

        // Handle specific validation error for existing reports
        if (
          err?.data?.error?.includes("already exists") ||
          err?.data?.existingReportId
        ) {
          const existingId = err?.data?.existingReportId
          setExistingReportId(existingId)
          setUploadError(
            err?.data?.error ||
              "A report already exists for this operator and customer combination."
          )

          // Show detailed error with delete suggestion
          Swal.fire({
            icon: "error",
            title: "Report Already Exists",
            html: `
              <div style="text-align: left;">
                <p>${
                  err?.data?.error ||
                  "A report already exists for this operator and customer combination."
                }</p>
                <p style="margin-top: 10px; font-weight: bold;">
                  Please delete the existing report (ID: ${existingId}) before uploading a new one.
                </p>
              </div>
            `,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
          })
        } else {
          // Handle other errors
          setUploadError(err?.data?.error || "Upload failed. Please try again.")
          Swal.fire(
            "Upload Failed",
            err?.data?.error || err?.data?.message || "Please try again.",
            "error"
          )
        }
      }
    } else {
      Swal.fire({
        icon: "error",
        text: "Please fill up the required fields.",
        confirmButtonColor: "#d33",
      })
    }
  }

  // UPDATED: Function to handle delete existing report with actual API call
  const handleDeleteExistingReport = async () => {
    if (existingReportId) {
      const result = await Swal.fire({
        title: "Delete Existing Report?",
        text: `Are you sure you want to delete report ID: ${existingReportId}? This action cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      })

      if (result.isConfirmed) {
        setIsDeleting(true)
        try {
          // ACTUAL API CALL TO DELETE THE REPORT
          await deleteReport(existingReportId).unwrap()

          Swal.fire(
            "Report Deleted!",
            `Report ID: ${existingReportId} has been successfully deleted. You can now upload a new report.`,
            "success"
          )

          // Clear the error state and allow new upload
          setUploadError("")
          setExistingReportId(null)
        } catch (error) {
          console.error("Error deleting report:", error)
          Swal.fire(
            "Delete Failed!",
            error?.data?.error ||
              "Failed to delete the report. Please try again.",
            "error"
          )
        } finally {
          setIsDeleting(false)
        }
      }
    }
  }

  return (
    <div>
      <Row>
        <h5 style={{ paddingTop: "10px", fontWeight: "bold" }}>
          Upload ENPT Reports
        </h5>
      </Row>

      {/* Error Alert for Existing Reports */}
      {uploadError && (
        <Row>
          <Col>
            <Alert color="danger" className="mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="alert-heading">Cannot Upload Report</h5>
                  <p className="mb-0">{uploadError}</p>
                  {existingReportId && (
                    <small className="text-muted">
                      Existing Report ID: <strong>{existingReportId}</strong>
                    </small>
                  )}
                </div>
                {existingReportId && (
                  <Button
                    color="danger"
                    size="sm"
                    onClick={handleDeleteExistingReport}
                    disabled={isDeleting}
                  >
                    {isDeleting ? "Deleting..." : "Delete Existing Report"}
                  </Button>
                )}
              </div>
            </Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <Card className="card_new3">
            <CardBody>
              <CardTitle>ENPT Report File</CardTitle>
              <Form>
                <Dropzone
                  maxFiles={1}
                  multiple={false}
                  validator={file => {
                    var x = file.path?.split(".")
                    let extension = x[x.length - 1]
                    if (
                      extension === "xlsx" ||
                      extension === "xls" ||
                      extension === "csv"
                    ) {
                      return null
                    } else {
                      return {
                        error: "Please Select SpreadSheet File to Continue",
                      }
                    }
                  }}
                  onDrop={acceptedFiles =>
                    handleAcceptedServerFiles(acceptedFiles)
                  }
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedReportFile.map((f, i) => (
                    <Card
                      key={i + "-file"}
                      style={{ boxShadow: "none" }}
                      className="mt-1 mb-0 shadow-none border"
                    >
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="rounded bg-light"
                              src={excelimage}
                            />
                          </Col>
                          <Col>
                            <a className="text-muted font-weight-bold">
                              {f.name}
                            </a>
                            <p className="mb-0">
                              <strong>{f.formattedSize}</strong>
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  ))}
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Single-file upload controls (always visible) */}
      <Row style={{ marginTop: "20px" }}>
        <Col sm="6" md="6" lg="6">
          <div>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isSearchable={true}
              name="Customer"
              placeholder="Select Customer"
              value={
                customerOptions.find(
                  option => option.value === selectedCustomer
                ) || null
              }
              options={customerOptions}
              onChange={selected => {
                if (selected && selected.value) {
                  setCustomer(selected.value)
                  dispatch(getNewOperators({ customer_id: selected.value }))
                } else {
                  setCustomer("")
                  dispatch(getNewOperators())
                }
              }}
            />
          </div>
        </Col>

        <Col sm="6" md="6" lg="6">
          <div>
            <Select
              placeholder="Select Operator"
              className="basic-single"
              classNamePrefix="select"
              value={
                operatorOptions.find(
                  option => option.value === selectedOperator
                ) || null
              }
              isSearchable={true}
              name="Operator"
              options={operatorOptions}
              onChange={selected => {
                if (selected && selected.value) {
                  setOperator(selected.value)
                } else {
                  setOperator("")
                }
              }}
            />
          </div>
        </Col>
      </Row>

      <Row style={{ marginTop: "10px", backgroundColor: "white" }}>
        <Col>
          <div className="d-flex ">
            <Button
              color="danger"
              className="btn btn-custom ms-auto p-2"
              onClick={UploadButtonHandler}
              disabled={!selectedReportFile[0] || uploadError}
            >
              Upload Report
            </Button>
          </div>
        </Col>
      </Row>

      <Modal isOpen={modal_pipe_upload}>
        <ModalHeader>Upload Files</ModalHeader>
        <ModalBody>
          <LoadingSpinnerUpload />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </div>
  )
}

export default EnptReportUpload
